module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/sara_humph-a0889c055339bc1bd36428414d9e217e.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/sara_humph.png
// module id = 2498
// module chunks = 2